import {
  AkaAdvicePriceFormValues,
  AkaDisabilityAdviceFormValues,
} from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka/AkaAdviceCards/interfaces";
import {
  getEducation,
  getWorkStatus,
} from "Store/advice/productPriceRequestMappers/disabilityPriceRequestMapper";

import { AdviceProductDetailsFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductDetails/FormElements/interfaces";
import { OneTimePaymentAdvisorChoice } from "Components/Features/CheckPrice/Products/Advice/ProductPrice/AdviceCards/interfaces";
import { BackendProductInfo } from "Components/Features/CheckPrice/Products/productConstants";
import { DisabilityPriceRequest } from "Store/akaAdvice/interfaces/AdviceProductPriceRequests";
import { AdvicePriceCalculationRequest } from "Store/akaAdvice/interfaces/AkaAdviceState";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { isDefined } from "Utils/functions";
import { mapHasEmployerPaidDisabilityInsurance } from "../utils";

export const mapToDisabilityPriceReq = (
  isAdvisor: boolean,
  formValues: AkaAdvicePriceFormValues,
  adviceDetailsFormValues: AdviceProductDetailsFormValues,
): {
  productPriceUrl: AdvicePriceCalculationRequest["productPriceUrl"];
  insuranceName: AdvicePriceCalculationRequest["insuranceName"];
  data: DisabilityPriceRequest;
} => {
  const {
    disabilityInsuredSumSlider,
    disabilityPaymentAfter3Months,
  }: AkaDisabilityAdviceFormValues = formValues;

  return {
    productPriceUrl: BackendProductInfo.DISABILITY.priceReqUrl,
    insuranceName: INSURANCE_NAME_VALUE.DISABILITY_FLEX,
    data: {
      insuredSum: disabilityInsuredSumSlider as number,
      coverageAmountCapital: mapOneTimePayment(isAdvisor, formValues),
      hasEmployerPaidDisabilityInsurance: mapHasEmployerPaidDisabilityInsurance(
        adviceDetailsFormValues,
      ),
      paymentAfter3Months: disabilityPaymentAfter3Months ?? false,
      workStatus: getWorkStatus(adviceDetailsFormValues.workSituation),
      education: getEducation(adviceDetailsFormValues.education),
      yearlyIncome: adviceDetailsFormValues.income,
      showComposites: true,
    },
  };
};

export const mapOneTimePayment = (
  isAdvisor: boolean,
  formValues: AkaDisabilityAdviceFormValues,
): number | null => {
  const disabilityOneTimePaymentValue =
    isDefined(formValues.disabilityOneTimePaymentValue) &&
    formValues.disabilityOneTimePaymentValue > 0
      ? formValues.disabilityOneTimePaymentValue
      : null;
  if (!isAdvisor) {
    if (formValues.disabilityOneTimePaymentCheckbox) {
      return disabilityOneTimePaymentValue;
    }
    return null;
  }
  switch (formValues.disabilityOneTimePaymentAdvisorChoice) {
    case OneTimePaymentAdvisorChoice.ADVICED_ONE_TIME_PAYMENT:
      return disabilityOneTimePaymentValue;
    case OneTimePaymentAdvisorChoice.CUSTOM_ONE_TIME_PAYMENT:
      return formValues.disabilityOneTimePaymentAdvisorValue ?? null;
    case OneTimePaymentAdvisorChoice.NO_ONE_TIME_PAYMENT:
    default:
      return null;
  }
};
